import React, { Component, Fragment } from "react"
import {
  BigCard,
  CardImg,
  Fromtext,
  DirectFlight,
  Flightdetail,
  SmallCard,
  TotalHeading,
  TotalPrice,
  SelectBtn,
  MainCard
} from "./elements"
import { FaArrowRight, FaPlane } from "react-icons/fa"
import CardDetail from "./CardDetail"
import {
  priceItinerary,
  getMajorFlightDetails,
  cabinClassArrayMulti,
  getNewFlightDuration
} from "filterFunctions"
import { TimeConvert24to12 } from "shared/ticketFuctions"

const MultiCityContainer = ({ data, updateProgress, allAirports }) => {
  return (
    <Fragment>
      {data.map((item, i) => (
        <MultiCityResults
          key={i}
          data={item}
          updateProgress={updateProgress}
          allAirports={allAirports}
        />
      ))}
    </Fragment>
  )
}

export default MultiCityContainer
class MultiCityResults extends Component {
  state = {
    showdetails: false
  }

  componentDidMount() {}

  showDetails = () => {
    this.setState({ showdetails: !this.state.showdetails })
  }
  render() {
    let { showdetails } = this.state
    let { updateProgress, data, allAirports } = this.props
    let {
      baggage_allowance,
      departing_flight_segments,
      price_itinerary,
      seats_remaining
    } = data
    let { amount, currency, cabin_code } = priceItinerary(price_itinerary)
    let cabinClassArr = cabinClassArrayMulti(cabin_code)
    return (
      <div>
        <MainCard>
          <div style={styleD} className="big-card" onClick={this.showDetails}>
            {data.trips &&
              data.trips.length &&
              data.trips.map((data, i) => (
                <FlightSegments
                  allAirports={allAirports}
                  data={data.departing_flight_segments}
                  key={i}
                  departing_flight_duration={data.departing_flight_duration}
                />
              ))}
            <Flightdetail onClick={this.showDetails}>
              Flight details
            </Flightdetail>
          </div>
          <SmallCard>
            <div>
              <TotalHeading>{currency}</TotalHeading>
              <TotalPrice>{amount.toLocaleString("en-IN")}</TotalPrice>
            </div>
            <SelectBtn onClick={() => updateProgress({ selectedFlight: data })}>
              Select <FaArrowRight />
            </SelectBtn>
          </SmallCard>
        </MainCard>
        {showdetails ? (
          <CardDetail
            hideDetails={this.showDetails}
            data={data}
            cabinClassArr={cabinClassArr}
          />
        ) : null}
      </div>
    )
  }
}

const FlightSegments = ({ data, departing_flight_duration, allAirports }) => {
  let {
    depTime,
    arrTime,
    depAirport,
    arrAirport,
    flightDuration,
    stopInt,
    sAValue,
    airlineName,
    totalDuration,
    airlineCode,
    arrivalCity,
    depCity
  } = getMajorFlightDetails(data, allAirports)
  let { DTime } = getNewFlightDuration(departing_flight_duration)
  return (
    <BigCard>
      <CardImg>
        <img
          src={`${process.env.REACT_APP_API_URL}v2/flight/airlines/logos/${airlineCode}`}
          alt="N/A"
        />
        <p>{airlineName}</p>
      </CardImg>
      <Fromtext title={`${depCity} (${depAirport})`}>
        <h4>{TimeConvert24to12(depTime)}</h4>
        <h5>
          {depCity}
          <br />({depAirport})
        </h5>
      </Fromtext>
      <DirectFlight>
        <h4>{DTime}</h4>
        {stopInt ? (
          <Fragment>
            <StopsImage stops={stopInt} />
            <h5 className="stop">
              {stopInt} Stop{" "}
              <span style={{ color: "#7c7b84" }}>({sAValue})</span>
            </h5>
          </Fragment>
        ) : (
          <Fragment>
            <StopsImage />
            <h5 className="direct">Direct</h5>
          </Fragment>
        )}
      </DirectFlight>
      <Fromtext title={`${arrivalCity} (${arrAirport})`}>
        <h4>{TimeConvert24to12(arrTime)}</h4>
        <h5>
          {arrivalCity} <br />({arrAirport})
        </h5>
      </Fromtext>
    </BigCard>
  )
}

const styleD = {
  borderRadius: "10px",
  background: "#fff",
  display: "flex",
  flexDirection: "column",
  width: "67%"
}

export const StopsImage = ({ stops }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
      <div
        className="flight duration"
        style={{
          borderBottom: "2px solid #ccc",
          flex: 9,
          position: "relative",
          display: "flex",
          justifyContent: "center"
        }}
      >
        {stops ? StopDots(stops) : null}
      </div>
      {/* <i className="fa fa-plane" style={{ flex: 1, marginLeft: "5px" }} /> */}
      <FaPlane style={{ flex: 1, marginLeft: "5px" }} />
    </div>
  )
}

const StopDots = stops => {
  let data = []
  for (let i = 1; i <= stops; i++) {
    data.push(
      <span
        key={i}
        style={{
          color: "red",
          fontSize: "14px",
          fontWeight: 500,
          lineHeight: "0px",
          marginRight: "5px"
        }}
      >
        &#9679;
      </span>
    )
  }
  return data
}
